import React, { useEffect, useState } from "react";
import {
    Card,
    Row,
    Col,
    Button
  } from "antd";
import IntlMessages from "../../../util/IntlMessages";
import SellAndTrackImg from "../../../assets/images/gift-cards-v1.svg";
import BoostRevenue from "../../../assets/images/boost-revenue-v1.svg";
import CustomiseCards from "../../../assets/images/customise-gift-cards-v1.svg";
import ds from "../../../Services/DataServices";
const GiftCards = () => {

    
    const [giftCardConfig, setGiftCardConfig] = useState(false);
    useEffect(() => {
        ds.getGiftCardConfiguration().then((res) => {
           
            res === 'True' ? setGiftCardConfig(true) : setGiftCardConfig(false);
        })
        // console.log("giftcard",giftCardConfig);
    },[])
    const updateGiftCards=()=>
    {
        ds.updateGiftCardConfiguration().then((res)=>
        {
            
            ds.getGiftCardConfiguration().then((res)=>{
                
                res === 'True' ? setGiftCardConfig(true) : setGiftCardConfig(false);
            })
        })
        // console.log("update",giftCardConfig);
    }
    return(
        <>
            <div className="gx-main-content-wrapper">
                <div>
                    <Card>
                        <Col md={24} className="custom-center-data">
                            <h1 className="">
                                <IntlMessages id="setup.giftCardsTitle" />
                            </h1>
                            <p className="custom-storeadd-head">
                                <IntlMessages id="setup.giftCards.cardSubText" />
                            </p>
                            <Button
                                className="custom-btn-addbtn"
                                type="primary"
                                onClick={() => updateGiftCards()}
                                >
                                <strong>
                                   {(giftCardConfig)?"Disable Gift Card":"Enable Gift Cards"}
                                </strong>
                            </Button>
                        </Col>
                    </Card>
                </div>
                <div>
                    <Row>
                        <Col md={8}>
                            <div className="gift-card-step">
                                <img src={SellAndTrackImg} alt="" />
                                <h2 className="gift-card-step-heading-v1">
                                    <IntlMessages id="setup.giftCards.sellAndTrack" />
                                </h2>
                                <p className="gift-card-step-details">
                                    <IntlMessages id="setup.giftCards.sellAndTrackDetail" />
                                </p>
                            </div>
                        </Col>
                        <Col md={8}>
                            <div className="gift-card-step">
                                <img src={BoostRevenue} alt="" />
                                <h2 className="gift-card-step-heading-v2">
                                    <IntlMessages id="setup.giftCards.boostRevenue" />
                                </h2>
                                <p className="gift-card-step-details">
                                    <IntlMessages id="setup.giftCards.boostRevenueDetail" />
                                </p>
                            </div>
                        </Col>
                        <Col md={8}>
                            <div className="gift-card-step">
                                <img src={CustomiseCards} alt="" />
                                <h2 className="gift-card-step-heading-v3">
                                    <IntlMessages id="setup.giftCards.customiseCards" />
                                </h2>
                                <p className="gift-card-step-details">
                                    <IntlMessages id="setup.giftCards.customiseCardsDetail" />
                                </p>
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
        </>
    );
}

export default GiftCards;